import React from "react";
import { Flex } from "@jsq/ds/core";
import { TextWithIcon, TextWithIconProps } from "../TextWithIcon";
import { paymentStatusInfoWrapper, paymentStatusInfo } from "./styles_vanilla.css";

type SequenceTextWithIconProps = {
  items: TextWithIconProps[];
};

/**
 * Used to display a sequence of TextWithIcon components.
 * Eg: 1 Processing, 2 Settled, 3 Failed each with their respective icons
 */
export const SequenceTextWithIcon: React.FC<SequenceTextWithIconProps> = (props) => {
  const { items } = props;
  return (
    <Flex className={paymentStatusInfoWrapper}>
      {items.map((item, index) => (
        <Flex key={index} className={index == 0 ? "" : paymentStatusInfo}>
          <TextWithIcon key={index} {...item} />
        </Flex>
      ))}
    </Flex>
  );
};
